export const services = [
  {
    slug: 'finance',
    title: 'Finance',
    tagline: 'An expert to help you analyze, implement, and transform finance systems.',
    icon: 'TrendingUp',
    description: 'A Finance Trainer teaches individuals or teams essential financial skills, including budgeting, accounting, financial analysis, investments, and compliance. They simplify complex financial concepts, provide practical tools, and help learners apply financial knowledge to make informed decisions that support personal or organizational financial growth.',
    whyHire: [
      { title: 'Financial Literacy', desc: 'Build strong understanding of key financial concepts.' },
      { title: 'Better Decision-Making', desc: 'Enable smarter budgeting, investing, and cost control.' },
      { title: 'Compliance', desc: 'Train teams on financial regulations and best practices.' },
      { title: 'Efficiency', desc: 'Improve accuracy in financial reporting and analysis.' },
      { title: 'Business Growth', desc: 'Strengthen financial planning to support long-term success.' },
    ],
  },
  {
    slug: 'cloud-computing',
    title: 'Cloud Computing',
    tagline: 'Scale your infrastructure with certified cloud architects and engineers.',
    icon: 'Cloud',
    description: 'A Cloud Computing Trainer teaches individuals or teams how to design, deploy, and manage applications and services on cloud platforms. They cover core concepts like virtualization, networking, storage, security, and scalability while providing hands-on training on platforms such as AWS, Azure, or Google Cloud.',
    whyHire: [
      { title: 'In-Demand Skills', desc: 'Equip teams with expertise in leading cloud platforms.' },
      { title: 'Cost Efficiency', desc: 'Train staff to optimize resources and reduce cloud expenses.' },
      { title: 'Scalability', desc: 'Build capability to design and manage scalable cloud solutions.' },
      { title: 'Security & Compliance', desc: 'Ensure teams follow best practices for secure cloud use.' },
      { title: 'Future-Readiness', desc: 'Prepare organizations for digital transformation and innovation.' },
    ],
  },
  {
    slug: 'agentic-ai',
    title: 'Agentic AI',
    tagline: 'Build autonomous AI systems that reason, plan, and execute complex tasks.',
    icon: 'Bot',
    description: 'An Agentic AI Trainer teaches learners how to design, train, and manage AI agents capable of autonomous decision-making and task execution. They cover prompt engineering, workflow orchestration, tool integration, safety measures, and real-world applications to help teams effectively leverage agentic AI for complex problem-solving.',
    whyHire: [
      { title: 'Autonomous AI Skills', desc: 'Train teams to build AI agents that act independently.' },
      { title: 'Efficiency', desc: 'Enable automation of complex tasks and workflows.' },
      { title: 'Safety & Reliability', desc: 'Ensure AI agents operate securely and ethically.' },
      { title: 'Practical Application', desc: 'Apply agentic AI to real-world business problems.' },
      { title: 'Competitive Advantage', desc: 'Stay ahead with advanced AI capabilities.' },
    ],
  },
  {
    slug: 'ai-trainer',
    title: 'AI/ML Trainer',
    tagline: 'Upskill your workforce with expert-led AI and Machine Learning training.',
    icon: 'GraduationCap',
    description: 'An AI/ML Trainer teaches individuals or teams how to understand, build, and apply Artificial Intelligence and Machine Learning solutions. They cover data preparation, model training, evaluation, and deployment, while ensuring learners gain hands-on experience to apply AI/ML techniques to real-world business or research problems.',
    whyHire: [
      { title: 'Skill Development', desc: 'Build in-house expertise in AI and ML.' },
      { title: 'Hands-On Learning', desc: 'Train teams to apply models on real data.' },
      { title: 'Tool Proficiency', desc: 'Teach frameworks like TensorFlow, PyTorch, and Scikit-learn.' },
      { title: 'Business Impact', desc: 'Enable AI-driven solutions tailored to organizational goals.' },
      { title: 'Future-Readiness', desc: 'Prepare teams for rapid advancements in AI/ML technologies.' },
    ],
  },
  {
    slug: 'data-analyst',
    title: 'Data Analyst',
    tagline: 'Turn raw data into actionable insights with skilled data professionals.',
    icon: 'BarChart3',
    description: 'A Data Analyst Trainer teaches learners how to collect, clean, and interpret data, use analytical tools (like Excel, SQL, Python, or BI platforms), and create reports or visualizations. They guide trainees in applying data insights to solve business problems and support decision-making.',
    whyHire: [
      { title: 'Skill Development', desc: 'Equip staff with practical data analysis expertise.' },
      { title: 'Better Decision-Making', desc: 'Teach how to extract actionable insights from data.' },
      { title: 'Tool Proficiency', desc: 'Train staff in Excel, SQL, Python, and BI platforms.' },
      { title: 'Customized Learning', desc: 'Tailor training to business needs and industry challenges.' },
      { title: 'Improved Efficiency', desc: 'Build in-house capability to handle data faster and smarter.' },
    ],
  },
  {
    slug: 'ai-program-management',
    title: 'AI Program Management',
    tagline: 'Oversee complex AI initiatives from strategy to deployment.',
    icon: 'Layers',
    description: 'An AI Program Management Trainer equips professionals with the skills to plan, manage, and oversee AI initiatives. They teach how to align AI projects with business goals, manage cross-functional teams, ensure compliance, track performance, and deliver successful, scalable AI solutions efficiently.',
    whyHire: [
      { title: 'Strategic Alignment', desc: 'Ensure AI projects support business objectives.' },
      { title: 'Cross-Functional Skills', desc: 'Train teams to manage tech, business, and compliance needs together.' },
      { title: 'Risk Management', desc: 'Reduce project failures through structured methodologies.' },
      { title: 'Scalability', desc: 'Build capability to manage multiple AI initiatives effectively.' },
      { title: 'Efficiency', desc: 'Improve delivery speed, resource use, and measurable outcomes.' },
    ],
  },
  {
    slug: 'machine-learning',
    title: 'Machine Learning',
    tagline: 'Develop and deploy ML models that drive real business outcomes.',
    icon: 'Brain',
    description: 'A Machine Learning Trainer teaches learners how to build, train, and evaluate ML models. They cover data preprocessing, algorithm selection, model tuning, and deployment. Their role ensures trainees gain hands-on skills to apply ML techniques for solving real-world business and technical problems.',
    whyHire: [
      { title: 'Build Expertise', desc: 'Develop in-house talent with strong ML skills.' },
      { title: 'Practical Application', desc: 'Train teams to solve real-world problems using ML.' },
      { title: 'Tool Mastery', desc: 'Teach frameworks like TensorFlow, PyTorch, and Scikit-learn.' },
      { title: 'Innovation', desc: 'Enable AI-driven solutions tailored to business needs.' },
      { title: 'Future-Readiness', desc: 'Prepare teams for emerging technologies and evolving markets.' },
    ],
  },
  {
    slug: 'technical-content-writer',
    title: 'Technical Content Writer',
    tagline: 'Craft compelling, technically accurate content for your audience.',
    icon: 'FileText',
    description: 'A Technical Content Writer creates clear, accurate, and engaging content that explains complex technologies. They develop user guides, manuals, knowledge base articles, blogs, and product documentation. Their role bridges technical concepts and user understanding, ensuring information is accessible, useful, and aligned with business goals.',
    whyHire: [
      { title: 'Clarity', desc: 'Translate complex technical concepts into easy-to-understand content.' },
      { title: 'User Empowerment', desc: 'Create guides and documentation that improve product adoption.' },
      { title: 'Consistency', desc: 'Ensure all materials align with brand voice and standards.' },
      { title: 'Efficiency', desc: 'Reduce support queries with well-structured knowledge resources.' },
      { title: 'Credibility', desc: 'Build trust with accurate, professional, and high-quality technical content.' },
    ],
  },
  {
    slug: 'executive-coaches',
    title: 'Executive Coaches',
    tagline: 'Empower your leaders with personalized executive coaching programs.',
    icon: 'Users',
    description: 'An Executive Coach helps leaders enhance their performance, decision-making, and leadership skills. They provide guidance on communication, conflict management, emotional intelligence, and strategic thinking. Their role is to unlock potential, build confidence, and drive personal and organizational growth through tailored coaching sessions.',
    whyHire: [
      { title: 'Stronger Leadership', desc: 'Develop confident, effective leaders.' },
      { title: 'Better Decision-Making', desc: 'Enhance clarity and strategic thinking.' },
      { title: 'Improved Communication', desc: 'Build influence and collaboration skills.' },
      { title: 'Personal Growth', desc: 'Strengthen emotional intelligence and resilience.' },
      { title: 'Organizational Impact', desc: 'Drive higher performance and long-term business success.' },
    ],
  },
  {
    slug: 'leadership-development',
    title: 'Leadership Development',
    tagline: 'Build a pipeline of future-ready leaders across your organization.',
    icon: 'Award',
    description: 'A Leadership Development Trainer equips professionals with the skills needed to lead effectively. They design and deliver programs on communication, strategic thinking, decision-making, conflict resolution, and team management. Their role is to nurture confident, capable leaders who can drive growth and inspire organizational success.',
    whyHire: [
      { title: 'Stronger Leaders', desc: 'Cultivate confident and effective leadership at all levels.' },
      { title: 'Better Team Performance', desc: 'Improve collaboration, motivation, and productivity.' },
      { title: 'Strategic Growth', desc: 'Align leadership skills with long-term business goals.' },
      { title: 'Succession Planning', desc: 'Prepare future leaders for critical roles.' },
      { title: 'Organizational Impact', desc: 'Drive culture, innovation, and sustainable success.' },
    ],
  },
  {
    slug: 'generative-ai',
    title: 'Generative AI Trainer',
    tagline: 'Leverage cutting-edge generative AI trainers to upskill learners.',
    icon: 'Sparkles',
    description: 'A Generative AI Trainer fine-tunes AI models by curating, annotating, and reviewing data, creating training prompts, and evaluating outputs. They ensure responses are accurate, safe, and aligned with human values. Their role bridges technology and human feedback, continuously improving AI\'s performance, reliability, and relevance across tasks and domains.',
    whyHire: [
      { title: 'Improve Accuracy', desc: 'Ensure AI delivers precise and reliable outputs.' },
      { title: 'Enhance Safety', desc: 'Minimize risks by aligning responses with ethical and compliance standards.' },
      { title: 'Optimize Performance', desc: 'Continuously refine models for faster, smarter results.' },
      { title: 'Tailor to Business Needs', desc: 'Adapt AI behavior to specific industry or organizational goals.' },
      { title: 'Maximize ROI', desc: 'Unlock the full potential of AI for better efficiency and value.' },
    ],
  },
  {
    slug: 'digital-marketing',
    title: 'Digital Marketing',
    tagline: 'Grow your brand with data-driven digital marketing strategies.',
    icon: 'Megaphone',
    description: 'A Digital Marketing Trainer teaches individuals and teams how to build and execute effective online marketing strategies. They cover SEO, social media, content marketing, paid advertising, email campaigns, and analytics to help businesses grow their online presence and reach target audiences.',
    whyHire: [
      { title: 'Online Visibility', desc: 'Boost brand awareness across digital channels.' },
      { title: 'Lead Generation', desc: 'Drive qualified leads through targeted campaigns.' },
      { title: 'Data-Driven Strategy', desc: 'Make marketing decisions backed by analytics and insights.' },
      { title: 'Cost Efficiency', desc: 'Maximize marketing ROI with optimized spend allocation.' },
      { title: 'Competitive Edge', desc: 'Stay ahead with the latest digital marketing trends and tools.' },
    ],
  },
];

export const consultantCategories = [
  'Generative AI Trainer',
  'Data Analyst',
  'AI Program Management',
  'Machine Learning',
  'Executive Coaches',
  'Technical Content Writer',
  'AI/ML Trainer',
  'Leadership Development',
  'Finance',
  'Cloud Computing',
];

export const whatYouGet = [
  'Discover quality talent',
  'Get what you pay for',
  'Dedicated account manager',
  'Customized solutions',
  'Faster turnaround',
  'Dedicated support',
  'Tailored to your needs',
  'Higher retention rates',
  'Secure and timely payment process',
  'Ensured quality standards',
  'Flexibility and transparency',
  'Peace of mind',
];

export const freelancerCategories = [
  'Freelance Trainers',
  'Content Developers',
  'Executive Coaches',
  'Consultants',
];

export const hearAboutUsOptions = [
  'LinkedIn',
  'Facebook',
  'Twitter',
  'Instagram/Telegram group',
  'Google Search',
  'Friend/Colleague',
  'Other (Please specify)',
];

export const findTalentRequirements = [
  'Freelance Trainer',
  'Consultant with Industry Experts',
  'Content Development',
  'Data Analysis & Machine Learning',
  'Executive Coaching',
  'Design & Branding',
  'Digital Marketing',
  'Organization Online/Offline Training',
  'Other',
];

export const findWorkRequirements = [
  'Freelance Trainer',
  'Become a Consultant',
  'Content Developer',
  'Data Analyst',
  'AI/ML Expert',
  'Leadership Coach',
  'Other',
];
